const bodyStyle = { fontSize: "16px", lineHeight: 1.7, color: "rgba(10,9,7,0.85)", margin: 0 };
const taglineStyle = {
  fontFamily: "var(--font-serif)",
  fontSize: "24px",
  lineHeight: 1.3,
  color: "var(--color-ink)",
  margin: 0,
};

/**
 * "Förderer" copy, as provided directly by the association (replaces the
 * earlier generic "Fördermitgliedschaft" placeholder wording). No numeric
 * membership fee is stated here — that stays a placeholder decision for
 * the association, same treatment as elsewhere on the site.
 * German is the primary/authoritative wording; English is a courtesy
 * translation.
 */
export function MembershipDe() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <p style={taglineStyle}>Förderer werden</p>

      <p style={bodyStyle}>
        Große Abenteuer brauchen treue Gefährten – und genau das bist du als Förderer von Tales&amp;Legends.
      </p>
      <p style={bodyStyle}>
        Unsere Events entstehen mit viel Herzblut, ehrenamtlichem Engagement und einem kleinen, aber leidenschaftlichen
        Team. Als gemeinnützige Organisation reinvestieren wir alles, was wir einnehmen, direkt in die Qualität
        unserer Veranstaltungen: in Kulissen, Kostüme, Requisiten, Musik und die unzähligen kleinen Details, die aus
        einem Wochenende ein unvergessliches Erlebnis machen.
      </p>
      <p style={bodyStyle}>
        Als Förderer unterstützt du uns mit einem frei gewählten monatlichen Beitrag – und sicherst damit nicht nur
        einzelne Events, sondern die Zukunft unserer Welt. Du hilfst uns dabei, neue Geschichten zu erzählen, neue
        Spieler:innen willkommen zu heißen und LARP als lebendige Kulturform weiterzuentwickeln.
      </p>
      <p style={bodyStyle}>
        Du musst nicht auf einem Event dabei sein, um Teil von Tales&amp;Legends zu sein. Manchmal reicht es, im
        Hintergrund die Fackel zu halten – damit die Geschichte weitergeht.
      </p>
    </div>
  );
}

/** Courtesy translation — German is the primary wording (see MembershipDe). */
export function MembershipEn() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <p style={taglineStyle}>Become a Supporter</p>

      <p style={bodyStyle}>
        Great adventures need loyal companions – and that's exactly what you are as a supporter of Tales&amp;Legends.
      </p>
      <p style={bodyStyle}>
        Our events come to life through heart, volunteer commitment, and a small but passionate team. As a non-profit
        organization, we reinvest everything we earn directly into the quality of our events: sets, costumes, props,
        music, and the countless small details that turn a weekend into an unforgettable experience.
      </p>
      <p style={bodyStyle}>
        As a supporter, you help us with a monthly contribution of your choice – securing not just individual events,
        but the future of our world. You help us tell new stories, welcome new players, and grow LARP as a living
        cultural form.
      </p>
      <p style={bodyStyle}>
        You don't have to attend an event to be part of Tales&amp;Legends. Sometimes it's enough to hold the torch in
        the background – so the story can go on.
      </p>
    </div>
  );
}
